/**
 * Constant config, all static constant will be declare here
 */

import { authTokenName } from '../env';

/**
 * Auth token setup in cookie for different env
 *  - production: b_t_c_k
 *  - testnet: b_t_c_k_testnet
 *  - test: b_t_c_k_cheetah-test-1 / b_t_c_k_serval-test-1
 *  - dev: b_t_c_k_cheetah-dev-1 / b_t_c_k_serval-dev-1
 */
export { authTokenName };
